{
  "id": "sample",
  "version": 0,
  "name": "Sample Dataset",
  "author": "",
  "date": "2023-01-01",
  "url": "https://example.com",
  "strings": {
    "en": {
      "name": "Sample Dataset Name",
      "help": [
        "https://www.example.com/privacy/download",
        "(Log in with your account)",
        "Click the second entry in the list 'Download Your Data'",
        "For format select 'JSON'",
        "Click 'Download'",
        "Wait for the email and follow the instructions (takes 2-10 minutes usually)"
      ]
    },
    "de": {
      "name": "Sample Dataset Name",
      "help": [
        "https://www.example.com/privacy/download",
        "(Melde dich an)",
        "Klicke den zweiten Eintrag 'Deine Informationen herunterladen' an.",
        "Wähle das Format 'JSON' aus",
        "Klicke auf 'Datei erstellen'.",
        "Sie erhalten eine Email zum Herunterladen in etwa 2-10 Minuten."
      ]
    }
  },
  "instructions": [],
  "fileStructure": [],
  "optionalFileStructure": [],
  "hidden": true
}
